export const calculateQty = ({ isSelectingSize, variant }) => {
  if (isSelectingSize) return;

  if (variant && variant.projectSpecificData.availableQuantity > 0) {
    if (
      variant.projectSpecificData.availableQuantity > 0 &&
      variant.projectSpecificData.availableQuantity <= 10
    ) {
      return `${variant.projectSpecificData.availableQuantity} left in stock`;
    } else if (
      variant.projectSpecificData.availableQuantity > 10 &&
      variant.projectSpecificData.availableQuantity <= 20
    ) {
      return 'Style selling quick';
    }
  }
};
